import { cn } from '@/lib/utils';
import type { NotificationTab } from '@/lib/notifications/notification-types';

const TABS: { value: NotificationTab; label: string }[] = [
  { value: 'ALL', label: 'All' },
  { value: 'MARKETS', label: 'Markets' },
  { value: 'ACCOUNT', label: 'Account' },
];

export interface NotificationTabsProps {
  active: NotificationTab;
  onChange: (tab: NotificationTab) => void;
}

/**
 * The All / Markets / Account filter pills. Selected = purple border + text;
 * unselected = neutral border + dark text (per Figma). Drives server-side
 * filtering via the parent's list query.
 */
export function NotificationTabs({ active, onChange }: NotificationTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Notification filters"
      className="flex items-center gap-2"
      data-testid="notification-tabs"
    >
      {TABS.map((tab) => {
        const selected = tab.value === active;
        return (
          <button
            key={tab.value}
            role="tab"
            type="button"
            aria-selected={selected}
            data-testid={`notification-tab-${tab.value.toLowerCase()}`}
            onClick={() => onChange(tab.value)}
            className={cn(
              'rounded-full border px-4 py-1.5 text-sm font-medium transition-colors',
              selected ? 'border-accent text-accent' : 'border-border text-primary hover:border-accent/40',
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
